import { useStorePartsLazyQuery } from '../../../../graphql'
import { InventoryLocation } from 'inventory-web'

export default function useInventoryLocationIsEmpty() {
	const [ loadStoreParts ] = useStorePartsLazyQuery()

	return async( inventoryLocation: InventoryLocation ) => {
		const { data } = await loadStoreParts( { variables: {
			storeIds: [ parseInt( inventoryLocation.id, 10 ) ],
			excludeEmpty: true,
		} } )

		if ( !data?.storeParts?.length ) {
			return true
		}
		return false
	}
}
